export default "__VITE_ASSET__6531c006__"